export const environment = {
  production: true,
  env: 'prod',
  apiUrl: 'https://services.corecarbon.com/api/v1',
  tileServerUrl: 'https://services.corecarbon.com/tile-server',
  openAssetBaseUrl: 'https://assets.corecarbon.com',
  mapbox: {
    accessToken: 'pk.eyJ1IjoiY29yZS1jYXJib24iLCJhIjoiY21hNDI2dnBoMDJqajJ3cHd4czF1ZGtyNyJ9.4B9rPHHpCgYdtVPom6qe4Q',
    baseMap: 'mapbox://styles/core-carbon/cma422khn002n01s1ftovedk0',
    baseMapContour: 'mapbox://styles/core-carbon/cma423jq8002j01qwgrdp4vwh',
    contourStyleId: 'core-carbon/cma423jq8002j01qwgrdp4vwh',
    satelliteStyleId: 'core-carbon/cma422khn002n01s1ftovedk0',
  },
  cognito: {
    clientId: '7m3poohvbp5n35u9per810jagm',
    identityPoolId: 'us-east-1:528fb97e-fbc7-47fa-9730-11671ff53340',
    userPoolId: 'us-east-1_pjaaJAKsP',
  },
  googleAnalyticsID: 'G-Y2NR6X4V7E',
  payment: {
    stripe_connect_url: 'https://connect.stripe.com/express/oauth/authorize',
  },
  site: {
    maxSize: 5000,
    minSize: 40,
  },
};
